import useTranslation from 'customHooks/translate';

import { getYoutubeEmbedUrl, instructionVideoIds } from './instructionVideos';

type InstructionsProps = {
  showPageHeader?: boolean;
};

const Instructions = ({ showPageHeader = false }: InstructionsProps) => {
  const translation = useTranslation();

  return (
    <div
      className={
        showPageHeader
          ? 'mx-auto max-w-[1200px] px-[16px] py-[32px] md:px-[56px] md:py-[48px]'
          : 'p-[16px]'
      }
    >
      {showPageHeader && (
        <div className="mb-[32px] flex max-w-[720px] flex-col gap-[12px]">
          <h1 className="text-[28px] font-bold tracking-tight text-eerie-black md:text-[40px]">
            {translation.instructions.title}
          </h1>
          <p className="text-[16px] leading-relaxed text-charleston-green/70 md:text-[18px]">
            {translation.instructions.intro}
          </p>
        </div>
      )}
      <ul className="grid list-none grid-cols-1 gap-[24px] p-0 sm:grid-cols-2 lg:grid-cols-3">
        {instructionVideoIds.map((videoId, index) => {
          const guideLabel = `${translation.instructions.guide} ${index + 1}`;

          return (
            <li
              key={`instruction-video-${index}`}
              className="flex flex-col gap-[12px]"
            >
              <h2 className="text-[16px] font-semibold text-[#1D1D1D] md:text-[18px]">
                {guideLabel}
              </h2>
              {videoId?.trim() ? (
                <div className="relative w-full overflow-hidden rounded-[8px] border border-[#eee] pb-[56.25%]">
                  <iframe
                    className="absolute left-0 top-0 h-full w-full"
                    src={getYoutubeEmbedUrl(videoId.trim())}
                    title={guideLabel}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="flex min-h-[120px] items-center justify-center rounded-[8px] border border-dashed border-[#d9d9d9] bg-[#f5f7f9] px-[16px] py-[24px] text-center text-[14px] text-[#292d32] opacity-60">
                  {translation.instructions.videoPending}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Instructions;
